import { useEffect, useRef } from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import { Star } from 'lucide-react';
import Autoplay from 'embla-carousel-autoplay';

export const TestimonialSlider = () => {
  const plugin = useRef(
    Autoplay({ delay: 4000, stopOnInteraction: false })
  );

  const testimonials = [
    {
      initials: 'SM',
      name: 'Sarah Mitchell',
      title: 'Founder, Tech Startup',
      text: 'The team at Get Logo Trademarked made the entire trademark process seamless. Their expertise and professionalism gave me peace of mind knowing my brand was in good hands.'
    },
    {
      initials: 'JR',
      name: 'James Rodriguez',
      title: 'Owner, E-commerce Brand',
      text: 'Excellent service from start to finish. They handled everything professionally and kept me updated throughout the process. Highly recommend for anyone looking to protect their brand.'
    },
    {
      initials: 'EC',
      name: 'Emily Chen',
      title: 'Creative Director',
      text: 'Fast, efficient, and transparent pricing. They answered all my questions and made sure I understood every step. My trademark was approved without any issues!'
    },
    {
      initials: 'MB',
      name: 'Michael Brown',
      title: 'CEO, Software Company',
      text: 'Outstanding trademark registration service! They conducted a thorough search, filed everything correctly, and my trademark was approved on the first try. Their attention to detail is impressive.'
    },
    {
      initials: 'LW',
      name: 'Lisa Wang',
      title: 'Founder, Fashion Brand',
      text: 'I have worked with several trademark services, and Get Logo Trademarked is by far the best. Their case manager kept me informed every step of the way, and they responded to USPTO office actions quickly and professionally.'
    },
    {
      initials: 'DP',
      name: 'David Parker',
      title: 'Owner, Restaurant Group',
      text: 'Protecting our restaurant brand was critical for expansion. They registered our trademark efficiently and helped us enroll in Amazon Brand Registry. Excellent service and great value for the investment.'
    },
    {
      initials: 'KJ',
      name: 'Karen Johnson',
      title: 'Entrepreneur',
      text: 'Their comprehensive trademark search saved me from a costly mistake. They identified conflicts I never would have found on my own and helped me choose a stronger brand name that was successfully registered.'
    },
    {
      initials: 'RT',
      name: 'Robert Taylor',
      title: 'Founder, Healthcare Startup',
      text: 'Professional, knowledgeable, and responsive. They made trademark registration simple and stress-free. I highly recommend their services to any business owner serious about protecting their brand.'
    }
  ];

  return (
    <Carousel
      opts={{
        align: 'start',
        loop: true,
      }}
      plugins={[plugin.current]}
      className="w-full"
      data-testid="testimonial-carousel"
    >
      <CarouselContent>
        {testimonials.map((testimonial, index) => (
          <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
            <div className="bg-white border border-border p-8 h-full transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)]">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-accent text-accent" />
                ))}
              </div>
              <p className="text-base leading-relaxed text-muted-foreground mb-6">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center text-accent font-bold">
                  {testimonial.initials}
                </div>
                <div>
                  <div className="font-semibold text-primary">{testimonial.name}</div>
                  <div className="text-sm text-muted-foreground">{testimonial.title}</div>
                </div>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="hidden md:flex" />
      <CarouselNext className="hidden md:flex" />
    </Carousel>
  );
};
